import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const LabelWrapper = styled.div`
  font-size: 14px;
  margin-bottom: 4px;
  align-self: center;
`;

const Label = ({ children, className }) => (
  <LabelWrapper className={className}>
    {children}
  </LabelWrapper>
);

Label.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

Label.defaultProps = {
  className: '',
};

export default Label;



// WEBPACK FOOTER //
// ./app/components/Label/index.js